import "./ResImage.css";

export default function ResImage() {
  return (
    <div className="resImageContainer">
      <img
        src="/assets/images/residential.jpg"
        className="resImage"
        alt="Residential"
      />
      <h1 className="resText">Residential Buildings</h1>
    </div>
  );
}
